var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "py-4",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.RepairEstimateResponseCard.text")) + " ")])])], 1), _vm._l(_vm.value.lineItems, function (lineItem, index) {
    return _c('v-row', {
      key: 'li' + index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": index > 0 ? 10 : 12,
        "md": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('objects.invoiceLine.title') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.title,
        callback: function callback($$v) {
          _vm.$set(lineItem, "title", $$v);
        },
        expression: "lineItem.title"
      }
    })], 1), index > 0 ? _c('v-col', {
      staticClass: "d-flex d-sm-none",
      attrs: {
        "cols": "2"
      }
    }, [_c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [index > 0 ? _c('v-btn', {
      staticClass: "pa-6",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('v-col', {
      attrs: {
        "cols": "9",
        "md": "3"
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.amount') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.amount,
        callback: function callback($$v) {
          _vm.$set(lineItem, "amount", _vm._n($$v));
        },
        expression: "lineItem.amount"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "3",
        "md": "2"
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.taxRate') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "step": 1,
        "min": 0,
        "max": 100,
        "type": "number",
        "suffix": "%",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.taxRate,
        callback: function callback($$v) {
          _vm.$set(lineItem, "taxRate", _vm._n($$v));
        },
        expression: "lineItem.taxRate"
      }
    })], 1), index > 0 ? _c('v-col', {
      staticClass: "d-none d-sm-flex",
      attrs: {
        "cols": "1",
        "md": "1"
      }
    }, [_c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [index > 0 ? _c('v-btn', {
      staticClass: "mt-1 pa-2",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1);
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addInvoiceLine
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("invoice.addPosition")) + " ")], 1), _c('v-divider', {
    staticClass: "mt-6"
  }), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalNet, _vm.value.currency)) + " ")])])]), _vm._l(_vm.value.taxRates, function (taxRate) {
    return _c('tr', {
      key: 'taxRate' + taxRate
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }), _c('td', {
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "colspan": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxRate")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])])]), _c('td', {
      staticClass: "text-end",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.calcItemsPerTaxRate(taxRate), _vm.value.currency)) + " ")])]);
  }), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalGross, _vm.value.currency)) + " ")])])])], 2)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }